import { setAuthToken } from "@lib/auth/jwt";
import {
  ProfileAddDocument,
  ProfileAddMutation,
  ProfileAddMutationVariables,
} from "@graphql/api";

interface ProfileAddProps {
  email?: string;
  webId?: string;
  linkedReservations?: Array<string>;
  name?: string;
  options?: {
    noAutoLogin?: boolean;
  };
  password?: string;
  telephone?: string;
  groupId?: number;
}

interface ProfileAddReturn {
  error?: string;
  profileId?: number;
}

export default async function profileAdd({
  email,
  webId,
  linkedReservations,
  name,
  options = {},
  password,
  telephone,
  groupId,
}: ProfileAddProps): Promise<ProfileAddReturn> {
  const client = global.window.apolloClient;
  const mutVars: ProfileAddMutationVariables = {
    email,
    webId,
    linkedReservations,
    name,
    password,
    telephone,
    groupId,
  };
  const result = await client.mutate<ProfileAddMutation, ProfileAddMutationVariables>({
    mutation: ProfileAddDocument,
    variables: mutVars,
  });

  const success = result?.data?.profileAdd?.success,
    profileId = result?.data?.profileAdd?.profileId,
    errorMessage = result?.data?.profileAdd?.message,
    authToken = result?.data?.profileAdd?.auth?.token;

  if (success && profileId && !options?.noAutoLogin && authToken) {
    // Store the new JWT token in cookies - profiles are read directly from JWT
    setAuthToken(authToken);

    // Reset Apollo store to use the new token for subsequent requests
    await client.resetStore();
  }

  return { 
    error: errorMessage || undefined, 
    profileId: profileId || undefined 
  };
}
